module.exports = __webpack_public_path__ + "static/tdm_2plastic_bag-6360326d93676a1366d13d7cb3b73fa1.jpg";